import BaseRepository from '@/api/repositories/BaseRepository';
import { PDFDocumentTypes } from '@/api/models/PDFDocumentTypes';

export default class OnboardingRepository extends BaseRepository {
	get endpoint() {
		return 'api/onboarding';
	}

	updateCompanyData(data) {
		return this.put(`update-company-data`, {}, data);
	}

	updateCompanyLegalData(data) {
		return this.put(`update-company-legal-data`, {}, data);
	}

	updateCompanyAssets(data) {
		return this.put('update-company-assets', {}, data);
	}

	updatePDFBlueprints(data) {
		return this.put('update-pdf-blueprints', {}, data);
	}

	updateOpeningHours(id, data) {
		return this.put(`update-opening-hours/${id}`, {}, data);
	}

	updatePDFAppendix() {
		return this.put(`update-pdf-appendix`, {});
	}

	updateCompanyVariables(data) {
		return this.put('update-company-variables', {}, data);
	}

	updateRentalCarsPricing(data) {
		return this.put('update-rental-cars-pricing', {}, data);
	}

	updateRentalCarsExtraCosts(data) {
		return this.put('update-rental-cars-extra-costs', {}, data);
	}

	updateRentalCars(data) {
		return this.post('update-rental-cars', {}, data);
	}

	updateDamageAssessors(data) {
		return this.post('update-damage-assessors', {}, data);
	}

	updateLawyerOffices(data) {
		return this.post('update-lawyer-offices', {}, data);
	}

	updateStripeData() {
		return this.put('update-stripe-data');
	}

	updateCompanyFees(data) {
		return this.put('update-company-fees', {}, data);
	}

	updateExtraCosts(data) {
		return this.put('update-extra-costs', {}, data);
	}

	//nutzungsbedingungen
	downloadTosFile() {
		return this.get('download-tos', {}, { responseType: 'arraybuffer' });
	}
	//datenschutz
	downloadDataProtection() {
		return this.get('download-data-protection', {}, { responseType: 'arraybuffer' });
	}
	//support policy
	downloadSupportPolicy() {
		return this.get('download-support-policy', {}, { responseType: 'arraybuffer' });
	}
	// consent policy
	downloadConsentPolicy() {
		return this.get('download-consent-policy', {}, { responseType: 'arraybuffer' });
	}
	//dpa/avv
	downloadDpaAvvFile() {
		return this.get('download-dpa-avv', {}, { responseType: 'arraybuffer' });
	}
	//dpa/avv anhang 1
	downloadDpaAvvAnnex1File() {
		return this.get('download-dpa-attachment-one', {}, { responseType: 'arraybuffer' });
	}
	//dpa/avv anhang 2
	downloadDpaAvvAnnex2File() {
		return this.get('download-dpa-attachment-two', {}, { responseType: 'arraybuffer' });
	}

	downloadCommunityRules() {
		return this.get('download-community-rules', {}, { responseType: 'arraybuffer' });
	}

	downloadAccountActivity() {
		return this.get('download-account-activity', {}, { responseType: 'arraybuffer' });
	}

	downloadDataProtectionUS() {
		return this.get('download-data-protection-us', {}, { responseType: 'arraybuffer' });
	}

	skipStep(step) {
		return this.put(`skip-step?step=${step}`, {}, {});
	}

	updateTos() {
		return this.put('update-tos');
	}

	updateConnectContract() {
		return this.put('update-contract');
	}

	downloadConnectContract() {
		return this.get('download-contract', {}, { responseType: 'arraybuffer' });
	}

	// old Routes for signing
	// updateContract(data, type = PDFDocumentTypes) {
	// 	return this.post(`update-contract/${type}`, data);
	// }
	//
	// downloadContract(uuid) {
	// 	return this.get(`download-contract/${uuid}`, {}, { responseType: 'arraybuffer' });
	// }

	updateInquired() {
		return this.put('inquired');
	}
}
